import request from '@/utils/request'

let Supply_qualificationApi = {

  /*政商企资质列表*/
  list(data) {
    return request._post('/shop/plus.supply_qualification.Index/index', data);
},
/*添加政商企资质*/
add(data) {
    return request._post('/shop/plus.supply_qualification.Index/add', data);
},
/*修改政商企资质*/
edit(data) {
    return request._post('/shop/plus.supply_qualification.Index/edit', data);
},
/*删除政商企资质*/
del(data) {
    return request._post('/shop/plus.supply_qualification.Index/del', data);
},
/*政商企资质详情*/
detail(data) {
  return request._post('/shop/plus.supply_qualification.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.supply_qualification.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.supply_qualification.Setting/getSetting', data, errorback);
    },
}
export default Supply_qualificationApi;



// WEBPACK FOOTER //
// ./src/api/supply_qualification.js